module.exports = __webpack_public_path__ + "img/zz2.6ddc86bb.jpg";